import axios from 'axios';


// export const API = axios.create({
//   baseURL: 'https://rullier.api.ova-consulting.fr/api',
//   timeout: 600000, // 600 secondes
// });


// Configuration de l'API
export const API_CONFIG = {
  BASE_URL: 'https://rullier-api.ova-consulting.fr/api',
  // BASE_URL: 'http://localhost:8000/api',
  TIMEOUT: 600000, // 600 secondes
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 seconde
};

// Endpoints de l'API
export const API_ENDPOINTS = {
  // Authentification
  AUTH: {
    LOGIN: '/auth/magento/oauth/',
    REFRESH: '/auth/refresh/',
    LOGOUT: '/auth/logout/',
  },
  
  // Projets
  PROJECTS: {
    LIST: '/be/user/projets/',
    DETAIL: (id) => `/be/user/projets/${id}/`,
    CREATE: '/be/user/projets/',
    UPDATE: (id) => `/be/user/projets/${id}/`,
    DELETE: (id) => `/be/user/projets/${id}/`,
  },
  
  // Étapes
  STEPS: {
    LIST: () => '/be/admin/steps/',
    LIST_BY_PROJECT: (projectId) => `/be/admin/steps/?projet=${projectId}`,
    DETAIL: (stepId) => `/be/admin/steps/${stepId}/`,
  },
  
  // Sections - Correction des endpoints selon l'API réelle
  SECTIONS: {
    LIST: () => '/be/admin/sections/',
    LIST_BY_STEP: (stepId) => `/be/admin/steps/${stepId}/sections/`,
    DETAIL: (sectionId) => `/be/admin/sections/${sectionId}/`,
  },
  
  // Contenus - Correction des endpoints selon l'API réelle
  CONTENTS: {
    LIST: () => '/be/admin/contents/',
    LIST_BY_SECTION: (sectionId) => `/be/admin/sections/${sectionId}/contents/`,
    DETAIL: (contentId) => `/be/admin/contents/${contentId}/`,
    SUBMIT: (contentId) => `/be/admin/contents/${contentId}/submit/`,
  },

  // Produits
  PRODUCTS: {
    LIST: () => '/be/admin/products/',
    DETAIL: (productId) => `/be/admin/products/${productId}/`,
  },

  // Inputs
  INPUTS: {
    LIST: () => '/be/admin/inputs/',
    DETAIL: (inputId) => `/be/admin/inputs/${inputId}/`,
  },

  // Autres choix
  OTHER_CHOICES: {
    LIST: () => '/be/admin/other-choices/',
    DETAIL: (choiceId) => `/be/admin/other-choices/${choiceId}/`,
  },

  // Documents
  DOCUMENTS: {
    UPLOAD: '/be/my-documents/',
    LIST: '/be/my-documents/',
    DETAIL: (id) => `/be/my-documents/${id}/`,
  },

  // Demandes
  DEMANDES: {
    CREATE: '/be/my-demandes/',
    LIST: (page = 1) => `/be/my-demandes/?page=${page}`,
    DETAIL: (id) => `/be/my-demandes/${id}/`,
  },

  // Réponses/Sélections
  RESPONSES: {
    CREATE: () => `/be/my-responses/`,
    // LIST: (demandeId) => `/be/user/responses/?demande=${demandeId}`,
    LIST: (demandeId) => `/be/my-responses/?demande=${demandeId}`,
    LIST_ALL: () => `/be/my-responses/`,
    DETAIL: (responseId) => `/be/user/responses/${responseId}/`,
    // UPDATE: (responseId) => `/be/user/responses/${responseId}/`,
    UPDATE: (responseId) => `/be/my-responses/${responseId}/`,
  },
};

// Codes d'erreur HTTP
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
}; 